import { z } from 'zod';

import { JobHistoryLevel } from '@/common/graphql';
import { DefinitionItem } from './language';

export const JobHistoryLevelDefinition = z.object({
  id: z.nativeEnum(JobHistoryLevel).default(JobHistoryLevel.L0),
  name: z.string().default(''),
  enabled: z.boolean().default(true),
  definitions: z.array(DefinitionItem).default([]),
  createdAt: z.string().default(''),
  updatedAt: z.string().default(''),
});
export type JobHistoryLevelDefinitionType = z.infer<typeof JobHistoryLevelDefinition>;
